module.exports = __webpack_public_path__ + "img/expar_logo_new.e7d3d0a4.svg";